<template>
  <div class="animated fadeIn">
    <template v-if="collection">
      <general-form
        v-for="(submission, index) in collection"
        :submission="submission"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        :turnArounds="
          sampleType && sampleType.getTurnarounds()
            ? sampleType.getTurnarounds()
            : null
        "
        :serviceQuestions="
          sampleType && sampleType.getServiceQuestions()
            ? sampleType.getServiceQuestions()
            : null
        "
        :index="index"
        :key="submission.key"
        @onSubmissionChange="onSubmissionChange"
        @removeSubmission="removeSubmission"
      >
      </general-form>
    </template>
    <b-button variant="success" block @click="newSubmission"
      ><i class="fal fa-plus"></i
    ></b-button>
  </div>
</template>

<script>
import GeneralForm from "./form/GeneralForm";
import Submission from "../../../models/legacy/Submission";
import TestPackageSampleCollection from "../../../collections/lab/TestPackageSampleCollection";
import TestPackageCollection from "../../../collections/lab/TestPackageCollection";

export default {
  name: "GeneralSubmissionForm",
  components: {
    GeneralForm
  },
  props: {
    submissions: {
      type: Array,
      default: () => []
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    testPackage: {
      type: Object,
      default: () => null
    },
    sampleType: {
      type: Object,
      default: () => null
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    }
  },
  data() {
    return {
      collection: []
    };
  },
  methods: {
    newSubmission() {
      this.collection.push(this.fillSubmission({}));
    },
    fillSubmission(data) {
      data = data || {};
      data = JSON.parse(JSON.stringify(data));
      data.sample_type = this.sampleType
        ? JSON.parse(JSON.stringify(this.sampleType))
        : null;
      data.test_package = this.testPackage
        ? JSON.parse(JSON.stringify(this.testPackage))
        : null;
      if (!data.samples || !data.samples.length) {
        data.samples = [];
        this.testPackageSamples.models.forEach(sample => {
          data.samples.push({
            test_package_sample_id: sample.id,
            identifier: sample.name
          });
        });
      }
      if (data.samples && data.samples.length) {
        data.samples.forEach((sample, index) => {
          this.testPackageSamples.models.forEach(testPackageSample => {
            if (testPackageSample.id === sample.test_package_sample_id) {
              sample.test_package_samples = [];
              let temp = JSON.parse(JSON.stringify(testPackageSample));
              sample.test_package_samples.push(temp);
              if (!sample.identifier) {
                sample.identifier = testPackageSample.name;
              }
            }
          });
          data.samples[index] = sample;
        });
      }
      return new Submission(data);
    },
    onSubmissionChange(params) {
      if (params && params.submission && params.index !== null) {
        this.collection.splice(
          params.index,
          1,
          this.fillSubmission(params.submission)
        );
        this.onSubmissionsChange();
      }
    },
    onSubmissionsChange() {
      this.$emit("onSubmissionsChange", this.collection);
    },
    removeSubmission(index) {
      if (index !== null) {
        this.collection.splice(index, 1);
      }
    }
  },
  mounted() {
    if (!this.submissions.length) {
      this.newSubmission();
    } else {
      this.submissions.forEach(submission => {
        this.collection.push(this.fillSubmission(submission));
      });
    }
  }
};
</script>
